// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	//for Menus
	document.querySelectorAll('.menu-restaurant__tabs li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.menu-restaurant__tabs li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.menu__unitmenu').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

	if (i === 0) btn.click();
	});

	//For Mobile Navigation
	document.addEventListener('DOMContentLoaded', function() {
		var headerCloseButton = document.querySelector('.header-close');
		var navMobile = document.querySelector('.nav-mobile');
		var headerMobile = document.querySelector('.header__mobile');

		function toggleActiveClass() {
			navMobile.classList.add('active');
			headerMobile.classList.add('active');
		}
		function removeActiveClass() {
			navMobile.classList.remove('active');
			headerMobile.classList.remove('active');
		}

		if (navMobile) {
			navMobile.addEventListener('click', toggleActiveClass);
		}
		if (headerCloseButton) {
			headerCloseButton.addEventListener('click', removeActiveClass);
		}
	});

	//For Opentable
	document.addEventListener('DOMContentLoaded', function() {
		var btnOpentable = document.querySelector('.js-opentable');
		var contentOpentable = document.querySelector('.open-table');

		function toggleActiveClass(e) {
			e.preventDefault();
			btnOpentable.classList.add('active');
			contentOpentable.classList.add('active');
		}
		function removeActiveClass() {
			btnOpentable.classList.remove('active');
			contentOpentable.classList.remove('active');
		}

		if (btnOpentable) {
			btnOpentable.addEventListener('click', toggleActiveClass);
		}
		if (headerCloseButton) {
			headerCloseButton.addEventListener('click', removeActiveClass);
		}
	});

	document.addEventListener('DOMContentLoaded', function() {
		var elements = document.querySelectorAll('[data-fancybox="gallery"]');

		elements.forEach(function(element) {
			if (!element.hasAttribute('data-lbx-group')) {
				element.setAttribute('data-lbx-group', 'gallery');
			}
			if (!element.hasAttribute('data-lbx-full')) {
				element.setAttribute('data-lbx-full', '');
			}
		});
	});
	

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    var swiper = new Swiper(".swiper-js", {
		slidesPerView: 4,
		centeredSlides: true,
		loop: true,
		spaceBetween: 15,
		navigation: {
			nextEl: ".swiper-button-prev",
			prevEl: ".swiper-button-next",
		},
		breakpoints: {
			340: {
				centeredSlides: false,
				slidesPerView: 1,
				spaceBetween: 0,
			},
			840: {
				centeredSlides: true,
				slidesPerView: 4,
				spaceBetween: 15,
			},
		},
	});

    var swiperHeder = new Swiper(".swiper-header", {
		slidesPerView: 1,
		loop: true,
		spaceBetween: 20,
		pagination: {
			el: ".swiper-pagination",
			dynamicBullets: true,
			clickable: true,
		},
	});
})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}